import { Form, Select, Typography } from "antd";
import React, { memo } from "react";
import { useController } from "react-hook-form";
import { checkFormFieldsEquality } from "./checkFormFieldsEquality";

export const CustomSelectField = (props) => {
  const {
    field,
    fieldState: { error, isTouched, isDirty },
  } = useController({
    name: props.name,
    control: props.control,
  });

  return (
    <Content
      {...props}
      field={field}
      error={error}
      isTouched={isTouched}
      isDirty={isDirty}
    />
  );
};

const Content = memo((props) => {
  const {
    field,
    error,
    formItem,
    name,
    shouldHideErrors,
    showErrors,
    ...inputProps
  } = props;
  delete inputProps.isTouched;
  delete inputProps.isDirty;
  return (
    <Form.Item
      name={name}
      validateStatus={error && (!shouldHideErrors || showErrors) ? "error" : ""}
      help={
        (!shouldHideErrors || showErrors) && error?.message != null
          ? error?.message
          : null
      }
      {...formItem}
    >
      <div>
        <Typography.Text>{props.children}</Typography.Text>
        <Select
          {...field}
          {...inputProps}
          onChange={(value) => {
            field.onChange(value);
            if (inputProps.onChange != null) {
              inputProps.onChange(value);
            }
          }}
        />
      </div>
    </Form.Item>
  );
}, checkFormFieldsEquality);
